<script lang="ts" setup>
definePageMeta({
  heroBackground: 'opacity-80 -z-10'
})
const [{ data: page }, { data: templates }] = await Promise.all([
  useAsyncData('templates-landing', () => useContent('site').get('/templates')),
  useAsyncData('templates', () => listByDir('/templates'))
])

if (!page.value) {
  throw createError({ statusCode: 404, statusMessage: 'Page not found', fatal: true })
}

const pageData = computed(() => page.value!.data)

const title = pageData.value.head?.title || pageData.value.title
const description = pageData.value.head?.description || pageData.value.description

const featuredTemplates = computed(() => templates.value?.filter(template => template.featured) || [])
const baseTemplates = computed(() => templates.value?.filter(template => !template.featured) || [])

useSeoMeta({
  titleTemplate: '%s',
  title,
  description,
  ogDescription: description,
  ogTitle: title
})
useCanonical()
defineOgImage('Docs.takumi', {
  title,
  description
})
</script>

<template>
  <UPage v-if="pageData">
    <UPageHero
      :title="pageData.title"
      :description="pageData.description"
      :links="pickLinks(pageData.links)"
    />
    <UPageBody>
      <UContainer>
        <div v-if="featuredTemplates.length" class="mb-24">
          <h2 class="text-2xl font-semibold mb-4 text-highlighted">
            Featured
          </h2>
          <UPageGrid class="lg:grid-cols-3 xl:grid-cols-4">
            <TemplateCard
              v-for="(template, index) in featuredTemplates"
              :key="template.slug"
              :template="template"
              :index="index"
            />
          </UPageGrid>
        </div>

        <div>
          <h2 class="text-2xl font-semibold mb-4 text-highlighted">
            Other
          </h2>
          <UPageGrid class="lg:grid-cols-3 xl:grid-cols-4">
            <TemplateCard
              v-for="(template, index) in baseTemplates"
              :key="template.slug"
              :template="template"
              :index="index + featuredTemplates.length"
            />
          </UPageGrid>
        </div>
      </UContainer>
    </UPageBody>
  </UPage>
</template>
